export const features =  {
    AllowCriticalEditsAdmin:true,
    AllowCountrySelection:false,
    WebsitePagesEnabled:false,
    MobileLoginEnabled:true,
    FacebookLoginEnabled:false,
    AppleLoginEnabled:false
};